<div class="card-header">
  <app-breadcrumb currentPage="transacties toevoegen"></app-breadcrumb>
</div>

<div class="card-body">
  <form class="form form-no-width" [formGroup]="formGroup">

    <div class="flex bigger">
      <div class="col-6">
        <span class="light inline-block mr16">startsaldo:</span> <span class="medium">
        {{currencyService.euro(balance?.amount)}}
    </span>
      </div>
      <div class="col-6">
        <span class="light inline-block mr16">per datum:</span> <span class="medium">{{balance?.date}}</span>
      </div>
    </div>

    <div class="spacer"></div>
    <p>
      open internetbankieren en achterhaal de start/- en eindsaldi<br>
      door deze in te vullen in combinatie met de transacties, kunnen wij de volledigheid controleren
    </p>

    <div [ngClass]="{ 'input-error':  submitted && f.closingBalance.errors }" style="width: 700px;">
      <label for="closingBalance" class="form-label">eindsaldo *</label>
      <div class="euro-field">
        <input formControlName="closingBalance" id="closingBalance" type="text">
      </div>
      <small>saldo na de laatste transactie</small>
      <div class="errors">
        <div *ngIf="f.closingBalance.errors?.required">eindsaldo is verplicht</div>
        <div *ngIf="!f.closingBalance.errors?.required && f.closingBalance.errors?.pattern">
          het verzoek een punt te gebruiken in plaats van een komma
        </div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>transacties toevoegen</h2>
    <table class="manual-import-table">
      <thead>
      <tr>
        <th style="width: 175px">datum *</th>
        <th style="width: 250px">bedrag *</th>
        <th style="width: 300px">IBAN</th>
        <th>omschrijving *</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr formArrayName="transactions" *ngFor="let transaction of getTransactions().controls let index = index">
        <ng-container [formGroupName]="index">

          <td [ngClass]="{'input-error': submitted && transaction.get('date').errors}">
            <input type="text" [id]="'date' + index" formControlName="date" placeholder="dd-mm-jjjj">
            <div class="errors">
              <div *ngIf="transaction.get('date').errors?.required">datum is verplicht</div>
              <div *ngIf="!transaction.get('date').errors?.required && transaction.get('date').errors?.validDate">
                datum is niet valid (dd-mm-jjjj)
              </div>
            </div>
          </td>

          <td class="euro-field small-euro-field"
              [ngClass]="{'input-error': submitted && transaction.get('amount').errors}">
            <input type="text" [id]="'amount' + index" formControlName="amount" class="small-input">
            <div class="errors pl40">
              <div *ngIf="transaction.get('amount').errors?.required">bedrag is verplicht</div>
              <div *ngIf="transaction.get('amount').errors?.pattern">
                het verzoek een punt te gebruiken in plaats van een komma
              </div>
            </div>
          </td>

          <td [ngClass]="{'input-error': submitted && transaction.get('iban').errors}">
            <input type="text" [id]="'iban' + index" formControlName="iban" class="small-input">
            <div class="errors pl40">
              <div *ngIf="transaction.get('iban').errors?.validAccountNumber">IBAN is niet geldig</div>
            </div>
          </td>

          <td
            [ngClass]="{'input-error': submitted && transaction.get('description').errors}">
            <textarea [id]="'description' + index" formControlName="description"
                      class="small-input manual-transaction-description"></textarea>
            <div class="errors pl40">
              <div *ngIf="transaction.get('description').errors?.required">omschrijving is verplicht</div>
            </div>
          </td>

          <td>
            <button class="btn times warning btn-left"
                    (click)="deleteTransaction(index)"
                    style="text-decoration: none; padding-right: 0; margin-top:-5px;">&nbsp;
            </button>
          </td>
        </ng-container>
      </tr>
      </tbody>
    </table>
    <small>markeer uitgaande transacties met een min-teken</small>

    <div class="spacer-large"></div>
    <button class="btn plus btn-left" (click)="addTransaction()">nieuwe rij toevoegen</button>
    <button class="btn check accent inverted float-right" (click)="manualImport()">
      transacties importeren
    </button>
  </form>
</div>
